function Price(props) {
    let symbol;
    switch(props.currency) {
        case 'GBP':
            symbol = '£';
            break;
        default:
            symbol = '$';
    }
    return (
        <span>{symbol} {props.value}</span>
    )
}

export default Price;